<template>
	<card class="filter" id="filterPrinter">
		
		<div class="tmplt-container" v-if="name>''">
			<el-tooltip content="Сохранить текущие настройки фильтра как 'Мой шаблон'" placement="bottom">
				<base-button type="primary" simple class="tmplt-btn mr-2" @click="saveLocalFilter"> <i class="tmplt-icon mx-1"></i> в Мой шаблон</base-button>
			</el-tooltip>
			<el-tooltip content="Подставить шаблон в фильтр" placement="bottom"><base-button type="primary" simple class="mr-1 tmplt-btn" @click="readLocalFilter">Мой шаблон</base-button></el-tooltip>
			<el-popover
				placement="bottom"
				title="Настройка шаблона"
				width="340"
				trigger="hover"
				content="">
				<template v-slot:reference>
					<i class="tim-icons text-primary icon-alert-circle-exc ml-2" style="font-size:18px;  margin-bottom: 4px;"></i>
				</template>
				<div>Выберите нужные параметры в фильтре. <br>Нажмите кнопку фильтра "Применить".<br>Нажмите кнопку "В Мой шаблон".<br>Ваш шаблон сохранен и будет применятся при открытии страницы.</div>
			</el-popover>
		</div>
		<base-button @click="HideFilter()" class="btn-close no-border my-0" type="primary" simple icon><i class="tim-icons icon-simple-remove"></i></base-button>
		
		<ReFilterOptions :masAllOptions="masAllFilterParams"  @value-change="valueChange" />
		
		<template v-slot:footer>
			<div class="bntGroup">
				<base-button @click="ApplyFilter()" type="success" simple class="mr-2">Применить</base-button> <base-button @click="ResetFilter()" type="danger" simple>Сбросить</base-button>
			</div>
		</template>
	</card>
</template>

<script>
	import {eventEmitter} from "src/plugins/globalComponents.js";
	import ReFilterOptions from './ReFilterOptions.vue';
	import { Tooltip, Popover } from 'element-ui';

	export default {
		name: 'ReFilter',
		components: {
			ReFilterOptions,
			[Tooltip.name]: Tooltip,
			[Popover.name]: Popover,
		},
		props: {
			masAllFilterParams: {
				type: Array,
				default() { return []; }
			},
			value: {
				type: Object,
				default() {	return {}; }
			},
			name:{
				type: String,
				default(){ return '';}
			},
			tags:{
				type: Boolean,
				default(){ return false;}
			}
		},
		data () {
			return {
				ver: 1,
				objPassthroughOpts: [],
				objCacheOpts: {},
				filterTags:[],
				optCount: '',
				masExcludeParams: ['page','p','c2p','AddComplexMinFlatsBig','dSortOrder','dSortType','dSearchType','client_id','taskend_id','task_id','service_id'],
				//objTags: {}
				callParentTimeoutFn:null,
				// external_params_map:{},
				params: {},
			}
		},
		computed: {
			storageFilterName(){
				return this.name+'-filter';
			}
		},
		methods: {
			callParent(){
				clearTimeout(this.callParentTimeoutFn);
				this.callParentTimeoutFn = setTimeout(()=>this.$emit('value-change',this.params), 10);
			},
			valueChange(event){
				// console.log('value change', event);
				if(event.element && event.element.elementGetParamMap){
					// console.log('set', this.params, event.element.elementGetParamMap, event.element.element_model);
					this.$set(this.params, event.element.elementGetParamMap, event.element.element_model);
					this.callParent();
					//this.$emit('value-change',this.params);
				}
				// if(this.external_params_map[event.element.elementGetParamMap]){
				// 	// передаём значения
				// 	this.external_params_map[event.element.elementGetParamMap].forEach(element=>{
				// 		// console.log('set',  event.element.elementGetParamMap, event.element.element_model);
				// 		this.$set(element.external_params_value, event.element.elementGetParamMap, event.element.element_model)
				// 	})
				// }
				// console.log(event, this.params, this);
			},
			saveLocalFilter(){
				this.buildCacheFilter();
				// console.log('save', this.objCacheOpts);
				localStorage.setItem(this.storageFilterName,JSON.stringify(this.objCacheOpts));
			},
			readLocalFilter(){
				this.loadLocalFilter();
				if(!this.$GVO.isEmpty(this.objCacheOpts)){
					//console.log(this.objCacheOpts);
					this.SetFilterParams();
					this.SendFilterChange(this.objCacheOpts);
				}
			},
			loadLocalFilter(){
				// Загружаем фильтры из локального хранилища
				if(this.name != ''){
					let filter=localStorage.getItem(this.storageFilterName);
					// console.log('load', filter);
					if(filter){
						try{
							this.objCacheOpts=JSON.parse(filter);
							//console.log(filter);
						}catch(e){

						}
					}
				}
			},
			SendFilterChange(objOts={}){
				this.$emit('input', objOts);
				this.$emit('filterapply', objOts);
				this.$emit('PushTags', this.filterTags);
			},
			ResetFilter(){
				//console.log('ResetFilter');
				this.filterTags = [];
				this.setToDefaultAllFilter();
				//this.SendFilterChange();
				this.ApplyFilter();
				this.callParent();
			},
			buildCacheFilter(){
				this.filterTags = [];
				for (let b=0;b<this.masAllFilterParams.length;b++) {
					for (let e = 0; e < this.masAllFilterParams[b].elements.length; e++) {
						const key = this.masAllFilterParams[b].elements[e].elementGetParamMap;
						if (!this.$GVO.isEmpty(this.masAllFilterParams[b].elements[e].element_model)) {
							if (this.masAllFilterParams[b].elements[e].elementType == 'select-tree'){
								if (!this.$GVO.isEmpty(this.masAllFilterParams[b].elements[e].element_model.selectedVal)) {
									this.objCacheOpts[key] = this.masAllFilterParams[b].elements[e].element_model.selectedVal;
									
									if(this.tags){
										this.filterTags.push({
											name: this.masAllFilterParams[b].elements[e].label, 
											val: this.masAllFilterParams[b].elements[e].element_model.selectedVal, 
											param_id: this.masAllFilterParams[b].elements[e].elementGetParamMap,
											descr: this.masAllFilterParams[b].elements[e].element_model.inputText, //для фильтра лидов
										});
									}

								}else{
									delete this.objCacheOpts[key];
								}
							} else if(this.masAllFilterParams[b].elements[e].elementType == 'input-date-range' || this.masAllFilterParams[b].elements[e].elementType == 'input-time-range' || this.masAllFilterParams[b].elements[e].elementType == 'input-range'){
								const masDtKeys = key.split('|');
								for (let index = 0; index < masDtKeys.length; index++) {
									delete this.objCacheOpts[masDtKeys[index]];
								}
								if(this.masAllFilterParams[b].elements[e].element_model.startDt != '' && typeof this.masAllFilterParams[b].elements[e].element_model.startDt !='undefined'){
									this.objCacheOpts[masDtKeys[0]] = this.masAllFilterParams[b].elements[e].element_model.startDt;
								}
								if(this.masAllFilterParams[b].elements[e].element_model.endDt != '' && typeof this.masAllFilterParams[b].elements[e].element_model.endDt !='undefined'){
									this.objCacheOpts[masDtKeys[1]] = this.masAllFilterParams[b].elements[e].element_model.endDt;
								}
								
								if(this.masAllFilterParams[b].elements[e].element_model.min != '' && typeof this.masAllFilterParams[b].elements[e].element_model.min !='undefined'){
									this.objCacheOpts[masDtKeys[0]] = this.masAllFilterParams[b].elements[e].element_model.min;
								}
								if(this.masAllFilterParams[b].elements[e].element_model.max != '' && typeof this.masAllFilterParams[b].elements[e].element_model.max !='undefined'){
									this.objCacheOpts[masDtKeys[1]] = this.masAllFilterParams[b].elements[e].element_model.max;
								}
							} else if(this.masAllFilterParams[b].elements[e].elementType == 'checkbox-group'){
								for (const key in this.masAllFilterParams[b].elements[e].element_model) {
									if (Object.hasOwnProperty.call(this.masAllFilterParams[b].elements[e].element_model, key)) {
										if (key.length>2 && this.masAllFilterParams[b].elements[e].element_model[key]==true) {
											this.objCacheOpts[key] = this.masAllFilterParams[b].elements[e].element_model[key]==true?1:0;
										} else if(typeof this.objCacheOpts[key] != 'undefined'){
											delete this.objCacheOpts[key];
										}
									}
								}
							} else if(this.masAllFilterParams[b].elements[e].elementType == 'select-cascade-services' || this.masAllFilterParams[b].elements[e].elementType == 'ajax-list-client'){
								this.objCacheOpts = {...this.objCacheOpts, ...this.masAllFilterParams[b].elements[e].element_model};

								if(this.tags){
									this.filterTags.push({name: this.masAllFilterParams[b].elements[e].label, val: this.masAllFilterParams[b].elements[e].element_model, param_id: this.masAllFilterParams[b].elements[e].elementGetParamMap});
								}

							} else if (this.tags && this.masAllFilterParams[b].elements[e].elementType == 'checkbox' && this.masAllFilterParams[b].elements[e].element_model != false){
								this.objCacheOpts[key] = this.masAllFilterParams[b].elements[e].element_model;
								this.filterTags.push({name: this.masAllFilterParams[b].elements[e].placeholder, val: this.masAllFilterParams[b].elements[e].label, param_id: this.masAllFilterParams[b].elements[e].elementGetParamMap});
								
							} else if(this.masAllFilterParams[b].elements[e].elementType == 'ajax-list'){
								this.objCacheOpts[key] = JSON.stringify(this.masAllFilterParams[b].elements[e].element_model);
								//console.log('buildCacheFilter', this.masAllFilterParams[b].elements[e].element_model);
								if(!this.$GVO.isEmpty(this.masAllFilterParams[b].elements[e].element_model.selectedVal) && this.tags){
									this.filterTags.push({name: this.masAllFilterParams[b].elements[e].label, val: this.masAllFilterParams[b].elements[e].element_model.inputText, param_id: this.masAllFilterParams[b].elements[e].elementGetParamMap});
								}

							} else if(this.masAllFilterParams[b].elements[e].elementType == 'select-objcat'){
								this.objCacheOpts[key] = JSON.stringify(this.masAllFilterParams[b].elements[e].element_model);
							} else if(this.masAllFilterParams[b].elements[e].elementType == 'date-range-strange'){
								const masDtKeys = this.masAllFilterParams[b].elements[e].elementGetParamMap.split('|');
								let rangeText = '';
								//console.log(masDtKeys);
								for (let index = 0; index < masDtKeys.length; index++) {
									delete this.objCacheOpts[masDtKeys[index]];
								}
								if(this.masAllFilterParams[b].elements[e].element_model[masDtKeys[0]]=='-1' && this.masAllFilterParams[b].elements[e].element_model[masDtKeys[1]].startDt != '' &&	this.masAllFilterParams[b].elements[e].element_model[masDtKeys[1]].endDt != ''){
									this.objCacheOpts[masDtKeys[1]] = this.masAllFilterParams[b].elements[e].element_model[masDtKeys[1]].startDt+';'+this.masAllFilterParams[b].elements[e].element_model[masDtKeys[1]].endDt;
									
									if(this.tags){
									this.filterTags.push({
										name: this.masAllFilterParams[b].elements[e].label, 
										val:this.masAllFilterParams[b].elements[e].element_model[masDtKeys[1]].startDt+';'+this.masAllFilterParams[b].elements[e].element_model[masDtKeys[1]].endDt, 
										param_id: this.masAllFilterParams[b].elements[e].elementGetParamMap});
									}
								}
								this.objCacheOpts[masDtKeys[0]] = this.masAllFilterParams[b].elements[e].element_model[masDtKeys[0]];

								if(this.masAllFilterParams[b].elements[e].element_model[masDtKeys[0]] == '5') {
									rangeText = 'год';
								} else if (this.masAllFilterParams[b].elements[e].element_model[masDtKeys[0]] == '2') {
									rangeText = 'месяц';
								} else if (this.masAllFilterParams[b].elements[e].element_model[masDtKeys[0]] == '0') {
									rangeText = 'день';
								} else if (this.masAllFilterParams[b].elements[e].element_model[masDtKeys[0]] == '-2') {
									rangeText = 'все';
								} else {rangeText = this.masAllFilterParams[b].elements[e].element_model[masDtKeys[0]]}
									if(this.masAllFilterParams[b].elements[e].element_model[masDtKeys[0]] != '-1'){
										if(this.tags){
										this.filterTags.push({name: this.masAllFilterParams[b].elements[e].label, val: rangeText, param_id: this.masAllFilterParams[b].elements[e].elementGetParamMap});
										}
									}
									
							} else if(this.masAllFilterParams[b].elements[e].elementType == 'radio-group' && this.tags){
								this.objCacheOpts[key] = this.masAllFilterParams[b].elements[e].element_model;

								let radiostr = '';
								//console.log(key,this.masAllFilterParams[b].elements[e].element_model);
								if(this.masAllFilterParams[b].elements[e].elementGetParamMap == 'isNewBuilding'){
									if(this.masAllFilterParams[b].elements[e].element_model == '1'){
										radiostr = 'Новостройка';
									} else if (this.masAllFilterParams[b].elements[e].element_model == '0'){
										radiostr = 'Вторичка';
									}else if (this.masAllFilterParams[b].elements[e].element_model == '4'){
										radiostr = 'Иное';
									}else if (this.masAllFilterParams[b].elements[e].element_model == ''){
										radiostr = 'Все';
									}
									this.filterTags.push({name: this.masAllFilterParams[b].elements[e].label, val: radiostr, param_id: this.masAllFilterParams[b].elements[e].elementGetParamMap});
								}
								//this.filterTags.push({name: this.masAllFilterParams[b].elements[e].label, val: this.masAllFilterParams[b].elements[e].element_model, param_id: this.masAllFilterParams[b].elements[e].elementGetParamMap});

							}else {
								//console.log(key,this.masAllFilterParams[b].elements[e].element_model);
								this.objCacheOpts[key] = this.masAllFilterParams[b].elements[e].element_model;
								if(this.masAllFilterParams[b].elements[e].element_model != false && this.tags){
									this.filterTags.push({name: this.masAllFilterParams[b].elements[e].label, val: this.masAllFilterParams[b].elements[e].element_model, param_id: this.masAllFilterParams[b].elements[e].elementGetParamMap});
								}
								
							}
						}else{
							//this.filterTags = [];
							delete this.objCacheOpts[key];
							if( this.masAllFilterParams[b].elements[e].elementType == 'input-date-range' || 
								this.masAllFilterParams[b].elements[e].elementType == 'input-time-range' ||
								this.masAllFilterParams[b].elements[e].elementType == 'checkbox-group'   || 
								this.masAllFilterParams[b].elements[e].elementType == 'input-range'
							){
								const masDtKeys = key.split('|');
								for (let index = 0; index < masDtKeys.length; index++) {
									delete this.objCacheOpts[masDtKeys[index]];
								}
							}
						}
					}
				}
			},
			ApplyFilter(){
				this.filterTags = [];
				this.buildCacheFilter();
				//console.log('ApplyFilter_filter',this.$GVO.unlinkObject(this.objCacheOpts));
				this.SendFilterChange(this.objCacheOpts);
				//this.setOptCount(this.objCacheOpts);
			},
			SetFilterParamsEmit(masFilterParams){
				// console.log('SetFilterParamsEmit', masFilterParams);
				//return true;
				if(this.masAllFilterParams.length==0){
					for (const key in masFilterParams) {
						if (masFilterParams.hasOwnProperty(key)) {
							// console.log(key);
							this.masAllFilterParams[key] = masFilterParams[key];
						}
					}
				}
				let objGetParams = this.$GVO.GetAllGet();
				// console.log(objGetParams);
				if(!this.$GVO.isEmpty(objGetParams)){
					this.objCacheOpts = this.$GVO.unlinkObject(objGetParams);

				}else{
					this.loadLocalFilter();
					
				}
				if(!this.$GVO.isEmpty(this.objCacheOpts)){
					// console.log('SetFilterParams');
					this.SetFilterParams();
					this.SendFilterChange(this.objCacheOpts);
				} else {
					// console.log('ApplyFilter');
					this.ApplyFilter();
				}
			},
			SetFilterParams(){
				this.objPassthroughOpts = [];
				// console.log(this.objCacheOpts);
				for (const key in this.objCacheOpts) {
					if (this.objCacheOpts.hasOwnProperty(key)) {
						let element = this.GetConfElement(key);
						// console.log(key,element);
						if(element === false){
							this.objPassthroughOpts.push(key);
						}else{
							if(element.elementType == 'select-tree'){
								let masRetTree = [];
								this.$GVO.SeachTreeReq(this.$GVO.masTreeOrgStruct,'id',this.objCacheOpts[key],masRetTree);
								element.element_model = {inputText: masRetTree[0].name, selectedVal:this.objCacheOpts[key]};
							} else if(element.elementType == 'input-date-range' || element.elementType == 'input-time-range'){
								if(element.elementGetParamMap.indexOf(key+'|') != -1){
									element.element_model.startDt = this.objCacheOpts[key];
								}
								if(element.elementGetParamMap.indexOf('|'+key) != -1){
									element.element_model.endDt = this.objCacheOpts[key];
								}
							} else if(element.elementType == 'input-range'){
								if(element.elementGetParamMap.indexOf(key+'|') != -1){
									element.element_model.min = this.objCacheOpts[key];
								}
								if(element.elementGetParamMap.indexOf('|'+key) != -1){
									element.element_model.max = this.objCacheOpts[key];
								}
							} else if(element.elementType == 'checkbox-group'){
								const masDtKeys = element.elementGetParamMap.split('|');
								for (let i = 0; i < masDtKeys.length; i++) {
									if(masDtKeys[i] == key){
										// console.log(key,typeof this.objCacheOpts[key], this.objCacheOpts[key], element.element_model[key]);
										if(typeof this.objCacheOpts[key] === 'string')
											element.element_model[key] = this.objCacheOpts[key]=='true'||this.objCacheOpts[key]=='1'?true:false;
										if(typeof this.objCacheOpts[key] === 'boolean')
											element.element_model[key] = this.objCacheOpts[key];
										// console.log(key, element.element_model[key]);
									}
								}
							} else if(element.elementType == 'checkbox'){
								element.element_model = this.objCacheOpts[key]=='true'?true:false;
							} else if(element.elementType == 'switcher'){
								element.element_model = this.objCacheOpts[key]=='true'?true:false;
							} else if(element.elementType == 'select'){
								if(element.multiple){
									if(typeof this.objCacheOpts[key] === 'string'){
										element.element_model = this.objCacheOpts[key].split(',');
									}else{
										element.element_model = this.objCacheOpts[key];
									}
								}else{
									element.element_model = this.objCacheOpts[key];
								}
							} else if(element.elementType == 'select-cascade-services'){
								//console.log(key,this.objCacheOpts[key]);
								element.element_model[key]=this.objCacheOpts[key];
							} else if(element.elementType == 'ajax-list-client'){
								//console.log(key,this.objCacheOpts[key]);
								element.element_model[key]=this.objCacheOpts[key];
							} else if(element.elementType == 'ajax-list'){
								//console.log(key,this.objCacheOpts[key]);
								element.element_model=JSON.parse(this.objCacheOpts[key]);
							} else if(element.elementType == 'select-objcat'){
								//console.log(key,this.objCacheOpts[key]);
								element.element_model=JSON.parse(this.objCacheOpts[key]);
							} else if(element.elementType == 'date-range-strange'){ 
								const masDtKeys = element.elementGetParamMap.split('|');
								//console.log(masDtKeys[0],this.objCacheOpts[masDtKeys[0]]);
								element.element_model[masDtKeys[0]]=this.objCacheOpts[masDtKeys[0]];
								if(typeof this.objCacheOpts[masDtKeys[1]] !='undefined'){
									const dates = this.objCacheOpts[masDtKeys[1]].split(';');
									element.element_model[masDtKeys[1]].startDt=dates[0];
									element.element_model[masDtKeys[1]].endDt=dates[1];
								}
							} else if(element.elementType == 'district-multi-picker'){
								//console.log(key,this.objCacheOpts[key].split(','));
								let arrData = [];
								if(this.objCacheOpts[key].indexOf(',')!=false){
									const dmpArr = this.objCacheOpts[key].split(',');
									for (let i = 0; i < dmpArr.length; i++) {
										arrData.push(parseInt(dmpArr[i]));
									}
								}else{
									arrData.push(parseInt(this.objCacheOpts[key]));
								}
								element.element_model = arrData;
							}else {
								element.element_model = this.objCacheOpts[key];
							}
						}
					}
				}
				//console.log('SetFilterParams', this.objPassthroughOpts);
			},
			SetToDefaultFilterValue(strElementMap2Filter){
				/*сбрасывает параметр фильтра к значениям по умолчанию*/
				for (let b=0;b<this.masAllFilterParams.length;b++) {
					for (let e = 0; e < this.masAllFilterParams[b].elements.length; e++) {
						if (this.masAllFilterParams[b].elements[e].elementGetParamMap == strElementMap2Filter) {
							if (this.masAllFilterParams[b].elements[e].elementComponent == 'checkbox-group') {
								for (let ie=0;ie<this.masAllFilterParams[b].elements[e].options.length;ie++){
									const optKey = ie=0;ie<this.masAllFilterParams[b].elements[e].options[ie].key;
									this.masAllFilterParams[b].elements[e].element_model[optKey] = this.GetDefaultValue(this.masAllFilterParams[b].elements[e].element_model_default[optKey]);
								}
							}else{
								this.masAllFilterParams[b].elements[e].element_model = this.GetDefaultValue(this.masAllFilterParams[b].elements[e].element_model_default);
							}
						}
					}
				}
			},
			setToDefaultAllFilter(){
				/*сбрасывает параметр фильтра к значениям по умолчанию*/
				for (var b=0;b<this.masAllFilterParams.length;b++) {
					for (var e = 0; e < this.masAllFilterParams[b].elements.length; e++) {
						this.SetToDefaultFilterValue(this.masAllFilterParams[b].elements[e].elementGetParamMap);
					}
				}
			},
			GetDefaultValue(obj){
				if(typeof obj == 'object'){
					const masKeys = Object.keys(obj);
					let retObj = {};
					for (let i = 0; i < masKeys.length; i++) {
						const key = masKeys[i];
						const val = obj[key]
						Object.defineProperty( retObj, key, {
							value: val,
							writable: false,
							enumerable: true,
							configurable: true
						});
					}
					return retObj;
				}else{
					let retObj = {};
					const key = 'onlyValue';
					const val = obj
					Object.defineProperty( retObj, key, {
						value: val,
						writable: false,
						enumerable: true,
						configurable: true
					});
					return retObj[key];
				}
			},
			GetConfElement(elementGetParamMap){
				//console.log('GetConfElement key',elementGetParamMap);
				//console.log('GetConfElement all_conf',this.masAllFilterParams);
				for (let i = 0; i < this.masAllFilterParams.length; i++) {
					for (let iEl = 0; iEl < this.masAllFilterParams[i].elements.length; iEl++) {
						if(this.masAllFilterParams[i].elements[iEl].elementGetParamMap == elementGetParamMap){
							return this.masAllFilterParams[i].elements[iEl];
						}
						if(this.masAllFilterParams[i].elements[iEl].elementGetParamMap.indexOf('|'+elementGetParamMap+'|') != -1){
							return this.masAllFilterParams[i].elements[iEl];
						}
						if(this.masAllFilterParams[i].elements[iEl].elementGetParamMap.indexOf(elementGetParamMap+'|') != -1){
							return this.masAllFilterParams[i].elements[iEl];
						}
						if(this.masAllFilterParams[i].elements[iEl].elementGetParamMap.indexOf('|'+elementGetParamMap) != -1){
							return this.masAllFilterParams[i].elements[iEl];
						}
					}
				}
				return false;
			},
			HideFilter(){
				eventEmitter.$emit('HideFilter', true);
			},
			LoadCats(){
				for (var b=0;b<this.masAllFilterParams.length;b++) {
					for (var e = 0; e < this.masAllFilterParams[b].elements.length; e++) {
						if (this.masAllFilterParams[b].elements[e].elementType == 'select' 
						) {
							//console.log(this.masAllFilterParams[b]);
							if(this.masAllFilterParams[b].elements[e].elementCat!=''){
							    this.masAllFilterParams[b].elements[e].options = this.$GVO.getCatToSelect(this.masAllFilterParams[b].elements[e].elementCat);
							}
						}
					}
				}
			},

		},
		mounted(){
			var me = this;
			// console.log(document.getElementById('filterPrinter'), this.$el);
			// document.getElementById('filterPrinter')
			this.$el.addEventListener('keyup', function(event) { //надо весить на кусочек по ИД
				if (event.keyCode === 13) { 
					//console.log('ApplyFilter');
					me.ApplyFilter();
				}
			});
		},
		created(){
			//this.LoadCats();
			eventEmitter.$on('OnFilterConfigLoad', this.SetFilterParamsEmit);
			eventEmitter.$on('ResetFilter', this.ResetFilter);
			eventEmitter.$on('RemoteApplyFilter', this.ApplyFilter);
			this.objCacheOpts = this.value;
			if(!this.$GVO.isEmpty(this.objCacheOpts)){
				this.SetFilterParams();
			}
			// this.setOptCount(this.value);
		},
		beforeDestroy() {
			// Отписываемся от события
			eventEmitter.$off('OnFilterConfigLoad', this.SetFilterParamsEmit);
			eventEmitter.$off('ResetFilter', this.ResetFilter);
			eventEmitter.$off('RemoteApplyFilter', this.ApplyFilter);
		},
	}
</script>
<style scoped>
	.filter{
		padding: 15px;
		border: 1px solid #01B0E0;
		border-radius: 30px;
		/*background: transparent;*/
	}
	.filter .btn-close{
		position: absolute;
		right:10px;
		top:0px;
	}
	.filter .bntGroup{
		display: flex;
		justify-content: flex-end;		
	}
	.filter .bntGroup > *{width: 125px;}
	.tmplt-btn {/*border-color: transparent;*/ padding: 0 3px; margin-top: 0;}
	/* .tmplt-btn:hover {border-color: transparent; } */
	.tmplt-container {position: absolute; top: 7px;}
	
	@media (max-width: 400px) {
		.filter-options {
			padding-top: 15px;
		}
	}
	
</style>
